export default "__VITE_ASSET__9sX1RIPV__"